module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "login_modal",
    attrs: {
      "id": "login_modal",
      "title": _vm.$t('message.login')
    },
    on: {
      "shown": _vm.clearLoginData
    }
  }, [_c('form', {
    ref: "loginModalForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.login($event)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.loginError.show
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loginError.message) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    ref: "login_modal_input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user.username')
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "loginPasswordId",
      "type": "password",
      "placeholder": _vm.$t('user.password')
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "keyup": _vm.onPasswordInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    ref: "capsLockTooltip",
    attrs: {
      "target": "loginPasswordId",
      "placement": "bottom",
      "disabled": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('forms.capsLockOn')) + "                  \n            ")])], 1), _vm._v(" "), _c('a', {
    staticClass: "reset-password-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.passwordResetModal
    }
  }, [_vm._v(_vm._s(_vm.$t('user.passwordForgotten')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('a', {
    staticClass: "initial-login-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.initialLoginModal
    }
  }, [_vm._v(_vm._s(_vm.$t('user.firstTimeLogin')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.load
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('forms.submit')) + "\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "initial_login_modal",
    attrs: {
      "id": "initial_login_modal",
      "title": _vm.$t('message.login'),
      "ok-only": ""
    },
    on: {
      "shown": _vm.clearInitialLoginData
    }
  }, [_c('form', {
    ref: "initialLoginModalForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.initialLogin($event)
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.loginError.show
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loginError.message) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    ref: "initial_login_modal_input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user.username')
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.load
    },
    on: {
      "click": _vm.initialLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('forms.submit')) + "\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "password_reset_modal",
    attrs: {
      "id": "password_reset_modal",
      "title": _vm.$t('user.passwordForgotten'),
      "ok-only": ""
    },
    on: {
      "shown": _vm.clearPasswordResetData
    }
  }, [_c('form', {
    ref: "passwordResetModalForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.loginError.show
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loginError.message) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    ref: "password_reset_modal_input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user.username')
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.load
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('forms.submit')) + "\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e589e72e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/login/Login.vue
// module id = 787
// module chunks = 1